import React, { useCallback, useEffect } from 'react';

import { useSciDomain } from 'components';
import { EventName, SciPage } from 'enums';
import { useViewComponent } from 'hooks';
import { PageLayoutViewProps } from 'types';
import { eventUtils } from 'utils';

export const PageLayout = () => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      eventUtils.sendEventBeforeUnload({ event: EventName.GatewayClosed });
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  const handleError = useCallback(
    (error: Error, info: { componentStack: string }) => {
      eventUtils.trackException({
        message: error.message,
        stack: info.componentStack,
      });
    },
    [],
  );

  const { data: { theme } = {} } = useSciDomain();

  useEffect(() => {
    if (theme) {
      document.documentElement.dataset.theme = theme;
    }
  }, [theme]);

  const PageLayoutView = useViewComponent(
    SciPage.PageLayout,
  ) as React.ComponentType<PageLayoutViewProps>;

  return <PageLayoutView handleError={handleError} />;
};
